import { Link } from "react-router-dom";
import { APP_LINKS, COMPANY } from "../../constants/site";
import { Icon } from "./Icon";
import { Logo } from "./Shared";

const EXPLORE = [
  { label: "Features", to: "/features" },
  { label: "Home Services", to: "/home-services" },
  { label: "Membership & Pricing", to: "/pricing" },
  { label: "For Service Professionals", to: "/for-service-professionals" },
  { label: "About HomeAligns", to: "/about" },
];

const SUPPORT = [
  { label: "Help Centre & FAQs", to: "/help" },
  { label: "Contact Us", to: "/contact" },
  { label: "Account & Data Requests", to: "/account-deletion" },
];

const LEGAL = [
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Terms & Conditions", to: "/terms" },
  { label: "Refund & Cancellation", to: "/refund-policy" },
];

const Col = ({ title, links, testid }) => (
  <div>
    <p className="mb-4 font-mono text-xs font-semibold uppercase tracking-[0.18em] text-white/50">{title}</p>
    <ul className="space-y-2.5">
      {links.map((l) => (
        <li key={l.to}>
          <Link
            to={l.to}
            data-testid={`${testid}-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}-link`}
            className="text-sm text-white/75 transition-colors duration-200 hover:text-white"
          >
            {l.label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

export const Footer = () => (
  <footer className="bg-teal-deep text-white">
    <div className="texture-grid">
      <div className="container-site grid gap-12 py-16 md:grid-cols-2 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <Logo dark />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/70">
            Everything your home needs, aligned in one place. Household assets, documents,
            warranties, maintenance and trusted home services — designed for households across India.
          </p>
          <div className="mt-6 space-y-2.5 text-sm text-white/75">
            <a
              href={`mailto:${COMPANY.supportEmail}`}
              data-testid="footer-support-email-link"
              className="flex items-center gap-2.5 transition-colors duration-200 hover:text-white"
            >
              <Icon name="Mail" className="h-4 w-4 text-teal-soft" />
              {COMPANY.supportEmail}
            </a>
            <p className="flex items-start gap-2.5">
              <Icon name="MapPin" className="mt-0.5 h-4 w-4 shrink-0 text-teal-soft" />
              <span>{COMPANY.address}</span>
            </p>
          </div>
        </div>
        <Col title="Explore" links={EXPLORE} testid="footer-explore" />
        <Col title="Support" links={SUPPORT} testid="footer-support" />
        <Col title="Legal" links={LEGAL} testid="footer-legal" />
      </div>

      <div className="border-t border-white/10">
        <div className="container-site flex flex-col gap-4 py-7 text-xs text-white/55 md:flex-row md:items-center md:justify-between">
          <p>
            © {new Date().getFullYear()} {COMPANY.operator} (CIN {COMPANY.cin}). All rights reserved.
          </p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <a href={APP_LINKS.login} data-testid="footer-login-link" className="transition-colors hover:text-white">
              Log In
            </a>
            <a
              href={APP_LINKS.registerVendor}
              data-testid="footer-vendor-link"
              className="transition-colors hover:text-white"
            >
              Join as a Service Professional
            </a>
            <span>Made for households across India</span>
          </div>
        </div>
      </div>
    </div>
  </footer>
);
